var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('product-list-component',{attrs:{"manager":true,"admin-super":_vm.adminSuper == 1 ? true : false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }